module.exports = __webpack_public_path__ + "6a8733c3a2c54c90c3db4bf58b1c6e14.png";